export default __webpack_public_path__ + "static/media/social-distancing.60217181.svg";